export const SURVEYEFFORT = "survey_effort_turtle";
export const SURVEYBREADCRUMB = "survey_breadcrumb_turtle";
export const SURVEYPRIMARY = "survey_turtle";
export const REFBREADCRUMB = "ref_breadcrumb_turtle_location";
export const SURVEYPRIMARYPHOTO = "survey_photo_turtle";
export const SURVEYSECONDARYPHOTO = "survey_photo_turtle";
export const SURVEYTERTIARYPHOTO = "survey_photo_turtle";
export const SURVEYSECONDARY = "survey_turtle";
export const SURVEYTERTIARY = "survey_turtle";

export const tabTableMap = { Turtle: SURVEYPRIMARY };

export const SURVEYEFFORTFIELDS = [
  { key: "id", type: "number" },
  { key: "incidental", type: "boolean" },
  { key: "insert_ts", type: "text" },
];
export const SURVEYBREADCRUMBFIELDS = [
  { key: "id", type: "number" },
  { key: "survey_ts", type: "text", keyField: true },
  { key: "survey_tablet", type: "text", keyField: true },
  { key: "ts", type: "text", keyField: true },
  { key: "longitude_wgs84", type: "number" },
  { key: "latitude_wgs84", type: "number" },
  { key: "incidental", type: "boolean" },
];

export const SURVEYPRIMARYFIELDS = [
  { key: "id", type: "number" },
  { key: "survey_ts", type: "text", keyField: true },
  { key: "survey_tablet", type: "text", keyField: true },
  { key: "longitude_wgs84", type: "number" },
  { key: "latitude_wgs84", type: "number" },
  { key: "turtle_count", type: "number" },
  { key: "turtle_code", type: "text", label: "Code" },
  { key: "observation_ts", type: "text", label: "Timestamp", keyField: true },
  { key: "tracks", type: "boolean", default: false },
  { key: "nest", type: "boolean", default: false },
  { key: "animal", type: "boolean", default: false },
  { key: "false_crawl", type: "boolean" },
  { key: "distance_water", type: "number" },
];
export const SURVEYSECONDARYFIELDS = [];
export const SURVEYTERTIARYFIELDS = [];

export const PHOTOFIELDS = [
  { key: "id", type: "number" },
  { key: "ts", type: "text", keyField: true },
];
